import React from 'react'
import withDefaults from 'src/utils/with-defaults'

interface Props {
  className?: string
}

const defaultProps = {
  className: '',
}

type NativeAttrs = Omit<React.HTMLAttributes<any>, keyof Props>
export type PageContentProps = Props & typeof defaultProps & NativeAttrs

const PageContent: React.FC<React.PropsWithChildren<PageContentProps>> = ({ className, children, ...props }) => {
  return (
    <div className={`content ${className}`} {...props}>
      {children}
      <style jsx>{`
        .content {
          padding: 5px;
        }
      `}</style>
    </div>
  )
}

export default withDefaults(PageContent, defaultProps)
